module.exports = __webpack_public_path__ + "static/media/LogoFroinBlanco.cc93448c.png";